<script>
/**
 * ****************************************************************************
 * @description     :   MainMenu
 * @created at      :   2022/03/24
 * @created by      :   ANS809 – quypn@ans-asia.com
 * @package         :   Frontier Consulting
 * @copyright       :   Copyright (c) A.N.S Asia
 * @version         :   1.0.0
 * ****************************************************************************
 */
/**
 * Import libraries
 */
import { mapState, mapActions } from 'vuex';

/**
 * import template
 */
import template from './template.html';

/**
 * Define main layout
 */
const MainMenu = {
    name: 'Menu',
    template: template,
    computed: {
        ...mapState('app', ['menus', 'isShowHalfMenu', 'isShowFullMenu'])
    },
    methods: {
        ...mapActions('app', ['showFullMenu', 'hideMenu']),
        onClickOutside: function (event) {
            if (
                event.target.className &&
                !event.target.className.includes('gn-menu-wrapper') &&
                !event.target.className.includes('btn-menu')
            ) {
                this.hideMenu();
            }
        }
    }
};
export default MainMenu;
</script>
